<template>
<svg
class="svgAdd"
@click="clicked"
    @mouseout="mouseover"
    @mouseleave="mouseleave"
    @mouseenter="mouseenter"
    @mousedown="mousedown"
     width="18" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="11" cy="11" r="11" fill="#3D56E6"/>
<path d="M10.9998 7.69922V15.3992" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.8506 11.55L7.15063 11.55" stroke="white" stroke-width="3"  stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
<script>
export default {
    props:["color"],
    methods: {
        clicked() {
            this.$emit('clicked')
        },
        mouseover() {
            this.$emit('mouseover')
        },
        mouseleave() {
            this.$emit('mouseleave')
        },
        mousedown() {
            this.$emit('mousedown')
        },
        mouseenter() {
            this.$emit('mouseenter')
        },
    }
}
</script>
<style>
.svgAdd:hover path {
    stroke:white;
    stroke-width:2;
}
.svgAdd:hover circle {
    stroke:#EF2035;
    stroke-width:2;
}
</style>